var map = {
	"./2021-11-28.json": 3463,
	"./2022-05-03.json": 3905,
	"./2022-11-23.json": 1576,
	"./2023-04-01.json": 1208,
	"./2023-04-02.json": 6785,
	"./2023-10-14.json": 8962,
	"./2023-10-28.json": 2389,
	"./2023-11-19.json": 5752,
	"./2023-11-24.json": 5524,
	"./2024-03-13.json": 2631,
	"./2024-04-07.json": 6713,
	"./2024-09-16.json": 617,
	"./2024-09-20.json": 9707,
	"./2024-10-29.json": 7245,
	"./2024-12-27.json": 3014,
	"./2025-04-06.json": 7873,
	"./2025-09-17.json": 5867,
	"./2025-10-21.json": 431,
	"./2025-11-24.json": 3242,
	"./2026-07-09.json": 6750,
	"./2026-08-06.json": 6291,
	"./2026-10-06.json": 5395,
	"./2026-11-01.json": 2711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3489;